import { Component, HostListener, Inject, LOCALE_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { QuoteService } from '../../../quote/services/quote.service';
import { FileService } from '../../services/file.service';
import { AbstractBiditComponent } from '../abstract.bidit.component';

interface MessageDialogData {
  message: string;
  title: string;
  confirmText: string;
  cancelText: string;
}

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message.dialog.html',
  styleUrls: ['./message.dialog.scss']
})
export class MessageDialog {

  constructor(deviceDetectorService: DeviceDetectorService,
    public dialogRef: MatDialogRef<MessageDialog>,
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogData) {
    
  }

  public close(value: any) {
    this.dialogRef.close(value);
  }

  public confirm() {
    this.close(true);
  }

  @HostListener("keydown.esc")
  public onEsc() {
    this.close(false);
  }


}
